export var SIMULATE_BUTTON = "simulate_button";
export var SIGNUP_BUTTON = "signup_button";
export var REGISTER_PAYMENT_METHOD_BUTTON = "register_payment_method_button";
export var FIRST_VISIT_TO_MYPAGE = "first_visit_to_mypage";
export var SUBMIT_SHIPPING_REQUEST_SURVEY_BUTTON = "submit_shipping_request_survey_button";
